import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationContextDatasourceService, ClientInfoDataSourceService } from '../../backend/datasource';
import { ThemeHandlerService } from '../service/theme-handler.service';
import { filter, tap, take, switchMap } from 'rxjs';

export const newViewResolver: ResolveFn<any> = route => {
  const urlObj = new URL(window.location.href, window.location.origin);
  const pathSegment = urlObj.pathname.split('/').filter(segment => segment)[0];

  const idp = { idp: pathSegment };
  const params = route.queryParams;

  const contextService = inject(AuthenticationContextDatasourceService);
  contextService.setContextData(params, idp);

  const themeService = inject(ThemeHandlerService);

  if (!contextService.getClientInfo()) {
    return inject(ClientInfoDataSourceService)
      .connect(contextService.getIdp())
      .pipe(
        filter(ci => ci != null),
        tap(result => contextService.setClientInfo(result)),
        take(1),
        switchMap(() => themeService.fetchTheme())
      );
  }

  return themeService.fetchTheme();
};
